/* eslint-disable no-shadow */
import React, {Component} from 'react';

import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux'

class PrivateRoute extends Component {
  render() {
    let typeParam, pathName
    console.log("this.props.user.userName = " + this.props.user.userName)
    const { component, ...rest } = this.props
    if (this.props.location.pathname === '/portal/app/learning_resources/my_learning_plan') {
      typeParam = 'learning_plan'
      pathName = `/portal/signin/${typeParam}`
    }
    else if (this.props.location.pathname === '/portal/app/opportunities') {
      typeParam = 'opportunity'
      pathName = `/portal/signin/${typeParam}`
    }
    else if (this.props.location.pathname === '/portal/app/user/about/tpo') {
      typeParam = 'certify'
      pathName = `/portal/signin/${typeParam}`
    }
    else if ((this.props.location.pathname === '/portal/app/tpo_registration_details') || (this.props.location.pathname === '/portal/app/tpo_registration')) {
      typeParam = 'tpo'
      pathName = `/portal/signin/${typeParam}`
    }
    else if (this.props.location.pathname === '/portal/app/user/questionnaires') {
      typeParam = 'questionnaires'
      pathName = `/portal/signin/${typeParam}`
    }

    else if (this.props.location.pathname === '/portal/app/user/survey_user_home') {
      typeParam = 'surveyhome'
      pathName = `/portal/signin/${typeParam}`
    }

    else if (this.props.location.pathname === '/portal/app/user/samplequiz_user_home') {
      typeParam = 'quizhome'
      pathName = `/portal/signin/${typeParam}`
    }
    else if (this.props.location.pathname === null || undefined || ''){
      typeParam = '1'
      pathName = `/portal/signin`
    }
    else{
      typeParam = '1'
      pathName = `/portal/signin`
    }

    return (
      <Route {...rest} render={(props) => (
        this.props.user.userName ? 
        React.createElement(this.props.component, props) : (
        <Redirect to={{
        pathname: pathName,
        state: { from: props.location },
        }} />
      ))} />
    )
  }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps(dispatch) {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(PrivateRoute)


// WEBPACK FOOTER //
// ./src/helpers/PrivateRoute.js